import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { InviteeType } from "../models/inviteetype"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class InviteeTypeService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'inviteetype/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllInviteeType(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<InviteeType>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllInviteeType?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewInviteeType(InviteeTypeID?: number): Observable<Array<InviteeType>> {
    return this.httpService.get(this.apiEndpoint + 'viewInviteeType/' + (InviteeTypeID ? InviteeTypeID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveInviteeType(inviteetypes: InviteeType): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveInviteeType/', inviteetypes).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  } 

  deleteInviteeType(InviteeTypeID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteInviteeType/' + (InviteeTypeID ? InviteeTypeID : '00000000-0000-0000-0000-000000000000'), InviteeTypeID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(InviteeTypeName?: string,InviteeTypeId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?InviteeTypeName=' + (InviteeTypeName ? InviteeTypeName : '')+ '&InviteeTypeId=' + (InviteeTypeId ? InviteeTypeId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
